export default function (val) {
  if (val === null || val === undefined) return null
  val = val.toString()
  return val !== '0' ? 
    `RM ${parseFloat(val.replace(/,/g, '')).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}` :
    'FREE'
}